import React from 'react';
import StepItem from './StepItem';
import HelpSection from './HelpSection';
import './Styles/Sidebar.css';


const steps = [
  {
    id: 1,
    title: 'Add your business',
    description: 'Enter your business domain to begin'
  },
  {
    id: 2,
    title: 'Customer base',
    description: 'Describe your target customers'
  },
  {
    id: 3,
    title: 'Offer & Benefits',
    description: 'Highlight what you offer and its advantages'
  },
  {
    id: 4,
    title: 'Competitors',
    description: 'List and analyse your competitors'
  },
  {
    id: 5,
    title: 'Business insights',
    description: 'Analyzing your market position'
  },
  {
    id: 6,
    title: 'Knowledge base',
    description: 'Provide business context'
  },
  {
    id: 7,
    title: 'Integration',
    description: 'Select tools to integrate with your business'
  },
];

const Sidebar = ({ currentStep, onStepChange }) => {
  return (
    <div className="sidebar2 d-flex flex-column">
      <div className="step-list">
        {steps.map((step) => (
          <StepItem
            key={step.id}
            step={step}
            isActive={currentStep === step.id}
            onClick={onStepChange}
          />
        ))}
      </div>
      <HelpSection />
    </div>
  );
};

export default Sidebar;